// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .if-logged {
  display: none;
}
:host .if-not-logged {
  display: inline-block;
}

:host-context(.logged) .if-logged {
  display: inline-block;
}
:host-context(.logged) .if-not-logged {
  display: none;
}

ion-header ion-button.button-logout ion-icon {
  font-size: 1.1rem;
}

.page-home__content {
  --padding-start: 0;
  --padding-end: 0;
}

.page-home__skeleton {
  padding: 8px 0 16px;
}

.page-home__skeleton-item {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.scss"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR;AAGI;EACI,qBAAA;AADR;;AAMI;EACI,qBAAA;AAHR;AAMI;EACI,aAAA;AAJR;;AASE;EACE,iBAAA;AANJ;;AAUA;EACE,kBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,cAAA;AAPF","sourcesContent":[":host{\n    .if-logged{\n        display: none;\n    }\n\n    .if-not-logged{\n        display: inline-block;\n    }\n}\n\n:host-context(.logged){\n    .if-logged{\n        display: inline-block;\n    }\n\n    .if-not-logged{\n        display: none;\n    }\n}\n\nion-header {\n  ion-button.button-logout ion-icon {\n    font-size: 1.1rem;\n  }\n}\n\n.page-home__content {\n  --padding-start: 0;\n  --padding-end: 0;\n}\n\n.page-home__skeleton {\n  padding: 8px 0 16px;\n}\n\n.page-home__skeleton-item {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
